<template>
  <div id="manage">
    <div class="content">
        <div class="title">订单管理</div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <input type="password"  autocomplete="new-password" style="display: none;">
                        <Input 
                        id="demo" 
                        v-model="keyword" 
                        icon="ios-search" 
                        placeholder="请用户名进行搜索" 
                        style="width: 200px;height:34px;border:1px solid #e7e7eb;margin:20px 0;" 
                        class="bradius" 
                        @on-click="search(1)" 
                        @keyup.enter.native="search(1)" 
                        autocomplete="off"></Input>
                        <Select v-model="orderId" placeholder="请选择订单类型" class="borDiv" style="width:200px;border:1px solid #e7e7eb;margin:20px 0;" @on-change="search(1)">
                            <Option v-for="item in orderlList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                    <!-- <div class="fl_right addClass" @click="addRecruit">新增学员</div> -->
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading"></Table>
                </div>
                <Page :page-size="pageSize" :total="total" show-total :current="pageNum" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
            </div>
            <div class="alertBox" v-if="alertShow">
                <div class="tanchuan">
                    <div class="tantop">
                        <div class="fl_left tantitle">{{valm==1?'编辑':'新增'}}</div>
                        <div class="fl_right tandel" @click="tandel"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="tancenter">
                        <div class="list listpad">
                            <div class="fl_left name">姓名</div>
                            <div class="fl_left inputBox">
                                <Input v-model="name" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入学员姓名" />
                                <input type="text"  autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">性别</div>
                            <div class="fl_left inputBox">
                                <RadioGroup v-model="teatsex">
                                    <Radio label="1">男</Radio>
                                    <Radio label="0">女</Radio>
                                </RadioGroup>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">舞种</div>
                            <div class="fl_left inputBox">
                                <Select v-model="dance" class="bordiv" placeholder="请选择等级" filterable @on-change="getLvel(1)" style="width:167px;margin-right:10px;height:36px;">
                                 <Option v-for="item in danceList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">等级</div>
                            <div class="fl_left inputBox">
                                <Select v-model="level_id" class="bordiv" placeholder="请选择等级" filterable style="width:167px;margin-right:10px;height:36px;">
                                 <Option v-for="item in levelArr" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                </Select>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="list listpad">
                            <div class="fl_left name">电话/登录账号</div>
                            <div class="fl_left inputBox">
                                <Input v-model="phone" class="bordiv" size="large" style="width:440px;" placeholder="请输入学员手机号" />
                                <input type="text" autocomplete="off" name="" style="display:none">
                            </div>
                            <div class="clear"></div>
                        </div>
                        
                    </div>
                    <div class="tanBtn" @click="tanyes(valm)">确定</div>
                </div>
            </div>
        </div>
        <el-dialog
            v-if="showShare"
            title="查看分成"
            :visible.sync="showShare"
            width="50%">
            <order-share :order_id="order_id" :order_money="order_money"></order-share>
        </el-dialog>
    </div>
  </div>
</template>

<script>
    import expandRow from './table-expand.vue';
    import OrderShare from './OrderShare.vue';
    
    export default {
        components: { expandRow ,OrderShare},
        name: 'manage',
        data () {
            return {
                showShare:false,
                order_id:'',
                order_money:'',
                orderlList:[
                    {name:'全部',id:-1},
                    {name:'报班',id:0},
                    {name:'课件(授课教师自购)',id:1},
                    {name:'课件(授课教师代购)',id:2},
                ],
                orderId:-1,
                name:'',
                keyword:'',
                level_id:'',
                levelArr:[],
                levalId:'',
                levelList:[],
                dance:'',
                danceList:[],
                dance_id:'',
                phone:'',
                teatsex:'0',
                teacher_id:'',
                total:null,
                pageNum:1,
                pageSize:10,
                loading:false,
                stop_reason:'',
                columns7: [
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },
                    {
                        title: '名称',
                        align: 'center',
                        key: 'goods',
                        render: (h, params) => {
                            return h('div',params.row.goods==''?'--':params.row.goods)
                        }
                    },
                    {
                        title: '类型',
                        align: 'center',
                        key: 'name',
                        render: (h, params) => {
                            if(params.row.type==1){
                                return h('div','课件(授课教师自购)')
                            }else if(params.row.type==2){
                                return h('div','课件(授课教师代购)')
                            }
                            else{
                                return h('div','报班')
                            }
                        }
                    },
                    {
                        title: '学员',
                        align: 'center',
                        key: 'name',
                        render: (h, params) => {
                            return h('div',params.row.name+'('+params.row.phone+')')
                        }
                    },
                    {
                        title: '有效期',
                        align: 'center',
                        key: 'expire_date',
                    },
                    {
                        title: '支付金额',
                        align: 'center',
                        key: 'money',
                    },
                    {
                        title: '支付时间',
                        align: 'center',
                        key: 'pay_time',
                    },
                    {
                        title: '支付类型',
                        align: 'center',
                        key: 'phone',
                        render: (h, params) => {
                            if(params.row.pay_type==0){
                                return h('div','支付宝支付')
                            }
                            else{
                                return h('div','微信支付')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'rate',
                        render: (h, params) => {
                            let _str    = '查看分成';
                            if(params.row.type == 2){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.order_id=params.row.id;
                                                _this.order_money=params.row.money;
                                                _this.showShare=true;
                                            }
                                        }
                                    },_str),
                                ]);
                            }else{
                                _str = "-";
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                    },_str),
                                ]);
                            }
                        }
                    }
                ],
                data6: [],
                alertShow:false,
                valm:0,
            }
        },
        methods:{
            tanyes(index){
                let _this=this;
                let pattern=/^1[3456789]\d{9}$/;//手机号验证
                let patternemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(_this.name==''){
                    this.$Message.error('请输入学员姓名');
                }
                else if(_this.dance==''){
                    this.$Message.error('请选择舞种');
                }
                else if(_this.level_id==''){
                    this.$Message.error('请选择等级');
                }
                else if(_this.phone==''){
                    this.$Message.error('请输入手机号');
                }
                else if(pattern.test(_this.phone)==false){
                    this.$Message.error('手机号输错了');
                }
                else{
                    if(index==0){
                        _this.$axios.post('addteacher',{
                            name:_this.name,
                            dance_id:_this.dance,
                            level_id:_this.level_id,
                            phone:_this.phone,
                            sex:_this.teatsex,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                    if(index==1){
                        _this.$axios.post('editteacher',{
                            teacher_id:_this.teacher_id,
                            name:_this.name,
                            dance_id:_this.dance,
                            level_id:_this.level_id,
                            phone:_this.phone,
                            sex:_this.teatsex,
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                }
            },
            tandel(){
                this.alertShow=false;
            },
            search(index){
                let _this=this;
                if(index==1){
                    _this.pageNum=1;
                }
                _this.$axios.post('getorderlist',{
                    keyword:_this.keyword,
                    page:_this.pageNum,
                    type:_this.orderId,
                }).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.data6=res.data.data.list;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.pageNum = num;
                this.search(0);
            },
            addRecruit(){
                let _this=this;
                _this.valm=0;
                _this.name='';
                _this.dance='';
                _this.level_id='';
                _this.teatsex='0';
                _this.getprovince();
                _this.phone='';
                _this.alertShow=true;
            },
            getprovince(){
                let _this=this; 
                _this.$axios.post('getdancelist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.danceList=res.data.data;
                        _this.dance=res.data.data[0].id;
                        _this.getLvel(1);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getLvel(index){
                let _this=this; 
                _this.$axios.post('getlevellist',{dance_id:index===0?_this.dance_id:_this.dance}).then(res=>{
                    if(res.data.code==200){
                        _this.levelArr=res.data.data;
                        _this.levelList=res.data.data;
                        if(index===0){
                            _this.levalId=res.data.data[0].id
                        }
                        else{
                            _this.level_id=res.data.data[0].id;
                        }
                        index===0?_this.search(1):'';
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            getscity(){
                let _this=this; 
                _this.$axios.post('getdancelist',{}).then(res=>{
                    if(res.data.code==200){
                        _this.danceList=res.data.data;
                        if(res.data.data.length!=0){
                            _this.dance_id=res.data.data[0].id;
                            _this.getLvel(0);
                        }
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
        },
        created(){
            let _this=this; 
            _this.search();
        }
    }
</script>
<style>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
</style>
<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
/**/
    .urlLogo{
        width: 150px;
        height: 210px;
        /*background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;*/
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/finance/order.vue